import { useEffect, useLayoutEffect, useRef } from 'react';
import { Dictionary } from '@direct-frontend/stdlib';

import { $internals, UnknownFormInstance } from '../form/types';
import { getFormsContext } from './FormsContext';

const TIMEOUT_TO_UNSUBSCRIBE = 300_000;

/** Создает подписку на данные формы */
export function useSubscription(instance: UnknownFormInstance) {
    const initializationId = instance[$internals].useFormInitializationId();
    // В качестве уникального ключа формы используем её name и id
    const instanceKey = `${instance.name}(${initializationId})`;
    const subscriptionsRef = useRef<Dictionary<Function>>({});

    const { shouldSaveSubscriptions } = getFormsContext();

    // Подписываемся на изменения и сохраняем знание об этом в ref
    // Это позволяет не подписываться на одну и ту же форму дважды
    useLayoutEffect(() => {
        if (!subscriptionsRef.current[instanceKey]) {
            subscriptionsRef.current[instanceKey] = instance.subscribe();
        }
    }, [instance, instanceKey]);

    // Отписываемся только при анмаунте или изменении `instanceKey`
    // Это позволяет не терять подписку при изменении ссылки на форму
    useEffect(() => {
        const subscriptions = subscriptionsRef.current;

        const unsubscribe = () => {
            subscriptions[instanceKey]?.();
            delete subscriptions[instanceKey];
        };

        return () => {
            if (shouldSaveSubscriptions) {
                setTimeout(() => {
                    unsubscribe();
                }, TIMEOUT_TO_UNSUBSCRIBE);
            } else {
                unsubscribe();
            }
        };
    }, [instanceKey, shouldSaveSubscriptions]);
}
